import React from 'react';
import MuiTextField from '@mui/material/TextField';
import { DatePicker as ModuleDatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker as ModuleDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePickerProps } from '.';

const filledTextFieldSlotProps = ({
  error,
  helperText,
  disabled,
  fullWidth,
  disableUnderline,
}: {
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  disableUnderline?: boolean;
}) => ({
  variant: 'filled' as const,
  error,
  helperText,
  disabled,
  fullWidth,
  slotProps: {
    input: {
      disableUnderline,
    },
    inputLabel: {
      shrink: true,
    },
  },
});

const outlinedTextFieldSlotProps = ({
  error,
  helperText,
  disabled,
  fullWidth,
  disableUnderline,
}: {
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  disableUnderline?: boolean;
}) => ({
  variant: 'outlined' as const,
  error,
  helperText,
  disabled,
  fullWidth,
  slotProps: {
    input: {
      disableUnderline,
    },
    inputLabel: {
      shrink: true,
    },
  },
});

const DatePicker = (props: DatePickerProps) => {
  const {
    dateValue,
    onDateChange,
    pickerType = 'date',
    styleVariant = 'standard',
    minDate,
    maxDate,
    disablePast = true,
    label = 'Date',
    error,
    helperText,
    disableUnderline = true,
    disabled,
    fullWidth = true,
    className,
  } = props;

  const format = pickerType === 'date' ? 'MM/DD/YYYY' : 'MM/DD/YYYY hh:mma';

  const commonProps = {
    disablePast,
    label,
    value: dateValue,
    minDate,
    maxDate,
    onChange: onDateChange,
    format,
    disabled,
    className,
  };

  const textFieldProps = {
    error,
    helperText: typeof helperText === 'string' ? helperText : undefined,
    disabled,
    fullWidth,
    disableUnderline,
  };

  if (styleVariant === 'standard') {
    return pickerType === 'date' ? (
      <ModuleDatePicker
        {...commonProps}
        slots={{
          textField: MuiTextField,
        }}
        slotProps={{
          textField: filledTextFieldSlotProps(textFieldProps),
        }}
      />
    ) : (
      <ModuleDateTimePicker
        {...commonProps}
        slots={{
          textField: MuiTextField,
        }}
        slotProps={{
          textField: filledTextFieldSlotProps(textFieldProps),
        }}
      />
    );
  }

  return pickerType === 'date' ? (
    <ModuleDatePicker
      {...commonProps}
      slotProps={{
        textField: outlinedTextFieldSlotProps(textFieldProps),
      }}
    />
  ) : (
    <ModuleDateTimePicker
      {...commonProps}
      slotProps={{
        textField: outlinedTextFieldSlotProps(textFieldProps),
      }}
    />
  );
};

export default DatePicker;
